
export const company_id = '6237be5b-35f0-48c6-9a61-5bc6033c6145'

export const EMPLOYEE_TYPES = [
    { value: 'SuperAdmin', label: 'Super Admin' },
    { value: 'RestaurantAdmin', label: 'Restaurant Admin' },
    { value: 'manager', label: 'Manager' },
    { value: 'cashier', label: 'Cashier' },
    { value: 'waiter', label: 'Waiter' },
    { value: 'kitchen_staff', label: 'Kitchen Staff' },
    { value: 'admin', label: 'Admin' },
]

export const component_types = [
    { label: 'Text Validator', value: 'TextValidator', haveValues: false },
    { label: 'Text Field', value: 'TextField', haveValues: false },
    { label: 'Dropdown', value: 'Dropdown', haveValues: true },
    { label: 'Radio Group', value: 'RadioGroup', haveValues: true },
    { label: 'Date Picker', value: 'DateValidator', haveValues: false },
    { label: 'Time Picker', value: 'TimeValidator', haveValues: false },
]

export const field_types = [
    { label: 'Number', value: 'Number' },
    { label: 'Text', value: 'Text' },

]

export const field_validations = [
    { label: 'Required', value: 'required', allowAddingValue: false },
    { label: 'Match Regular Expression', value: 'matchRegexp', allowAddingValue: true },
    { label: 'Is Email', value: 'isEmail', allowAddingValue: false },
    { label: 'Is Empty', value: 'isEmpty', allowAddingValue: false },
    { label: 'Trim', value: 'trim', allowAddingValue: false },
    { label: 'Is Number', value: 'isNumber', allowAddingValue: false },
    { label: 'Is Float', value: 'isFloat', allowAddingValue: false },
    { label: 'Is Positive', value: 'isPositive', allowAddingValue: false },
    { label: 'Minimum Number', value: 'minNumber', allowAddingValue: true },
    { label: 'Maximum Number', value: 'maxNumber', allowAddingValue: true },
    { label: 'Minimum Float', value: 'minFloat', allowAddingValue: true },
    { label: 'Maximum Float', value: 'maxFloat', allowAddingValue: true },
    { label: 'Is String', value: 'isString', allowAddingValue: false },
    { label: 'Minimum String Length', value: 'minStringLength', allowAddingValue: true },
    { label: 'Maximum String Length', value: 'maxStringLength', allowAddingValue: true },
    { label: 'Maximum File Size', value: 'maxFileSize', allowAddingValue: true },
    { label: 'Allowed Extensions', value: 'allowedExtensions', allowAddingValue: true },
];

export const COUNTRIES = [
    { label: 'Algeria', value: 'Algeria' },
    { label: 'Argentina', value: 'Argentina' },
    { label: 'Armenia', value: 'Armenia' },
    { label: 'Australia', value: 'Australia' },
    { label: 'Austria', value: 'Austria' },
    { label: 'Azerbaijan', value: 'Azerbaijan' },
    { label: 'Bahamas', value: 'Bahamas' },
    { label: 'Bahrain', value: 'Bahrain' },
    { label: 'Bangladesh', value: 'Bangladesh' },
    { label: 'Barbados', value: 'Barbados' },
    { label: 'Belarus', value: 'Belarus' },
    { label: 'Belgium', value: 'Belgium' },
    { label: 'Bolivia', value: 'Bolivia' },
    { label: 'Brazil', value: 'Brazil' },
    { label: 'Brunei', value: 'Brunei' },
    { label: 'Bulgaria', value: 'Bulgaria' },
    { label: 'Cambodia', value: 'Cambodia' },
    { label: 'Canada', value: 'Canada' },
    { label: 'Chile', value: 'Chile' },
    { label: 'China', value: 'China' },
    { label: 'Colombia', value: 'Colombia' },
    { label: 'Costa Rica', value: 'Costa Rica' },
    { label: 'Croatia', value: 'Croatia' },
    { label: 'Cuba', value: 'Cuba' },
    { label: 'Cyprus', value: 'Cyprus' },
    { label: 'Czech Republic', value: 'Czech Republic' },
    { label: 'Denmark', value: 'Denmark' },
    { label: 'Dominican Republic', value: 'Dominican Republic' },
    { label: 'Ecuador', value: 'Ecuador' },
    { label: 'Egypt', value: 'Egypt' },
    { label: 'Estonia', value: 'Estonia' },
    { label: 'Finland', value: 'Finland' },
    { label: 'France', value: 'France' },
    { label: 'Georgia', value: 'Georgia' },
    { label: 'Germany', value: 'Germany' },
    { label: 'Ghana', value: 'Ghana' },
    { label: 'Greece', value: 'Greece' },
    { label: 'Hong Kong', value: 'Hong Kong' },
    { label: 'Hungary', value: 'Hungary' },
    { label: 'Iceland', value: 'Iceland' },
    { label: 'India', value: 'India' },
    { label: 'Indonesia', value: 'Indonesia' },
    { label: 'Ireland', value: 'Ireland' },
    { label: 'Israel', value: 'Israel' },
    { label: 'Italy', value: 'Italy' },
    { label: 'Jamaica', value: 'Jamaica' },
    { label: 'Japan', value: 'Japan' },
    { label: 'Kazakhstan', value: 'Kazakhstan' },
    { label: 'Kenya', value: 'Kenya' },
    { label: 'Kuwait', value: 'Kuwait' },
    { label: 'Laos', value: 'Laos' },
    { label: 'Latvia', value: 'Latvia' },
    { label: 'Lithuania', value: 'Lithuania' },
    { label: 'Luxembourg', value: 'Luxembourg' },
    { label: 'Malaysia', value: 'Malaysia' },
    { label: 'Maldives', value: 'Maldives' },
    { label: 'Malta', value: 'Malta' },
    { label: 'Mexico', value: 'Mexico' },
    { label: 'Morocco', value: 'Morocco' },
    { label: 'Myanmar', value: 'Myanmar' },
    { label: 'Nepal', value: 'Nepal' },
    { label: 'Netherlands', value: 'Netherlands' },
    { label: 'New Zealand', value: 'New Zealand' },
    { label: 'Nigeria', value: 'Nigeria' },
    { label: 'Norway', value: 'Norway' },
    { label: 'Oman', value: 'Oman' },
    { label: 'Pakistan', value: 'Pakistan' },
    { label: 'Panama', value: 'Panama' },
    { label: 'Paraguay', value: 'Paraguay' },
    { label: 'Peru', value: 'Peru' },
    { label: 'Philippines', value: 'Philippines' },
    { label: 'Poland', value: 'Poland' },
    { label: 'Portugal', value: 'Portugal' },
    { label: 'Qatar', value: 'Qatar' },
    { label: 'Romania', value: 'Romania' },
    { label: 'Russia', value: 'Russia' },
    { label: 'Saudi Arabia', value: 'Saudi Arabia' },
    { label: 'Singapore', value: 'Singapore' },
    { label: 'Slovakia', value: 'Slovakia' },
    { label: 'Slovenia', value: 'Slovenia' },
    { label: 'South Africa', value: 'South Africa' },
    { label: 'South Korea', value: 'South Korea' },
    { label: 'Spain', value: 'Spain' },
    { label: 'Sri Lanka', value: 'Sri Lanka' },
    { label: 'Sweden', value: 'Sweden' },
    { label: 'Switzerland', value: 'Switzerland' },
    { label: 'Taiwan', value: 'Taiwan' },
    { label: 'Thailand', value: 'Thailand' },
    { label: 'Trinidad and Tobago', value: 'Trinidad and Tobago' },
    { label: 'Tunisia', value: 'Tunisia' },
    { label: 'Turkey', value: 'Turkey' },
    { label: 'Ukraine', value: 'Ukraine' },
    { label: 'United Arab Emirates', value: 'United Arab Emirates' },
    { label: 'United Kingdom', value: 'United Kingdom' },
    { label: 'United States', value: 'United States' },
    { label: 'Uruguay', value: 'Uruguay' },
    { label: 'Uzbekistan', value: 'Uzbekistan' },
    { label: 'Venezuela', value: 'Venezuela' },
    { label: 'Vietnam', value: 'Vietnam' },
];

export const SRI_LANKA_DISTRICTS = [
    { label: 'Ampara', value: 'Ampara' },
    { label: 'Anuradhapura', value: 'Anuradhapura' },
    { label: 'Badulla', value: 'Badulla' },
    { label: 'Batticaloa', value: 'Batticaloa' },
    { label: 'Colombo', value: 'Colombo' },
    { label: 'Galle', value: 'Galle' },
    { label: 'Gampaha', value: 'Gampaha' },
    { label: 'Hambantota', value: 'Hambantota' },
    { label: 'Jaffna', value: 'Jaffna' },
    { label: 'Kalutara', value: 'Kalutara' },
    { label: 'Kandy', value: 'Kandy' },
    { label: 'Kegalle', value: 'Kegalle' },
    { label: 'Kilinochchi', value: 'Kilinochchi' },
    { label: 'Kurunegala', value: 'Kurunegala' },
    { label: 'Mannar', value: 'Mannar' },
    { label: 'Matale', value: 'Matale' },
    { label: 'Matara', value: 'Matara' },
    { label: 'Monaragala', value: 'Monaragala' },
    { label: 'Mullaitivu', value: 'Mullaitivu' },
    { label: 'Nuwara Eliya', value: 'Nuwara Eliya' },
    { label: 'Polonnaruwa', value: 'Polonnaruwa' },
    { label: 'Puttalam', value: 'Puttalam' },
    { label: 'Ratnapura', value: 'Ratnapura' },
    { label: 'Trincomalee', value: 'Trincomalee' },
    { label: 'Vavuniya', value: 'Vavuniya' },
];